<template>
    <!-- <div>
        <el-row style="margin-top: 2vh; padding: 20px;">  
            <el-col :span="24" style="margin-top: 20px;">
                <el-table ref="tableRef" :data="deviceRecordList" height="70vh" style="width: 100%;" border
                    :header-cell-class-name="'table-header'" @row-click="handleRowClick" v-loading="loading">
                    <el-table-column type="selection" width="55" align="center" />
                    <el-table-column label="序号" type="index" width="70" align="center" />
                    <el-table-column prop="deviceId" label="设备序列号" align="center" />
                    <el-table-column prop="sampleName" label="样品名" align="center" />
                    <el-table-column prop="cabinetId" label="柜号" align="center" />
                    <el-table-column prop="storedHours" label="预存时间" align="center" />
                    <el-table-column prop="operaInCabTime" label="入柜时间" align="center" />
                    <el-table-column prop="operaOutCabTime" label="出柜时间" align="center" />
                    <el-table-column prop="operaInCabName" label="入柜操作人" align="center" />
                    <el-table-column prop="operaOutCabName" label="出柜操作人" align="center" />
                    <el-table-column prop="operationType" label="操作类型" align="center">
                        <template #default="scope">
                            {{ scope.row.operationType === 1 ? '入柜' : '出柜' }}
                        </template>
</el-table-column>
</el-table>
</el-col>
</el-row>
</div> -->
    <el-card>
        <div class="announcement-header">
            <div class="announcement-icon">
                <i class="el-icon-location-outline"></i>
            </div>
            <div class="announcement-title">留样记录</div>
        </div>
        <div class="device-table-container">
            <div class="checkin-overview-list">
                <div class="overview-header">
                    <div class="header-item">设备序列号</div>
                    <div class="header-item">样品名</div>
                    <div class="header-item">柜号</div>
                    <div class="header-item">预存时间</div>

                    <div class="header-item">入柜时间</div>
                    <div class="header-item">出柜时间</div>
                    <div class="header-item">入柜操作人</div>
                    <div class="header-item">出柜操作人</div>
                    <div class="header-item">操作类型</div>
                </div>
                <!-- 滚动列表的视窗容器 -->
                <div class="marquee-container">
                    <div class="overview-body">
                        <div class="overview-row" v-for="(item, index) in deviceRecordList" :key="index">
                            <div class="body-item">{{ item.deviceId }}</div>
                            <div class="body-item">{{ item.sampleName }}</div>
                            <div class="body-item">{{ item.cabinetId }}</div>
                            <div class="body-item"> {{ item.storedHours }}</div>
                            <div class="body-item"> {{ item.operaInCabTime }}</div>
                            <div class="body-item"> {{ item.operaOutCabTime }}</div>

                            <div class="body-item"> {{ item.operaInCabName }}</div>
                            <div class="body-item"> {{ item.operaOutCabTime }}</div>

                            <div class="body-item"> {{ item.operationType === 1 ? '入柜' : '出柜' }}</div>


                        </div>
                        <div class="empty-tip" v-if="deviceRecordList.length === 0">
                            暂无信息
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-card>
</template>

<script>
import { getKeepSampleList } from "@/api/sample";

export default {

    data() {
        return {
            // 搜索表单
            searchForm: {
                deviceId: ''
            },
            // 设备记录列表（当前页数据）
            deviceRecordList: [],
            // 分页参数
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            // 加载状态
            loading: false
        };
    },
    mounted() {
        this.getTemplateList();
    },
    methods: {
        // 获取设备记录列表（后端分页）
        async getTemplateList() {
            // 防止重复请求
            if (this.loading) return;

            this.loading = true;
            try {
                // 构造请求参数（包含分页和搜索条件）
                const params = {
                    pageNo: this.currentPage,    // 页码
                    pageSize: this.pageSize,    // 每页条数
                    deviceId: this.searchForm.deviceId || '' // 搜索条件
                };

                // 调用接口并传递分页+搜索参数
                const response = await getKeepSampleList(params);

                // 处理接口返回数据（适配常见的后端分页格式）
                if (response && response.data) {
                    // 情况1：后端返回标准分页格式 { list: [], total: 0 }
                    if (response.data.list && typeof response.data.total === 'number') {
                        this.deviceRecordList = response.data.list;
                        this.totalCount = response.data.total;
                    }
                    // 情况2：后端返回 { records: [], total: 0 } (MyBatis Plus格式)
                    else if (response.data.records && typeof response.data.total === 'number') {
                        this.deviceRecordList = response.data.records;
                        this.totalCount = response.data.total;
                    }
                    // 情况3：后端直接返回数组（兼容旧接口，前端模拟分页）
                    else if (Array.isArray(response.data)) {
                        this.deviceRecordList = response.data.slice(
                            (this.currentPage - 1) * this.pageSize,
                            this.currentPage * this.pageSize
                        );
                        this.totalCount = response.data.length;
                    }
                    // 情况4：其他自定义格式（根据实际接口调整）
                    else {
                        this.deviceRecordList = response.data || [];
                        this.totalCount = response.total || 0;
                    }
                }

                console.log('分页数据加载成功:', {
                    页码: this.currentPage,
                    每页条数: this.pageSize,
                    总条数: this.totalCount,
                    当前页数据量: this.deviceRecordList.length
                });

            } catch (error) {
                console.error('获取设备记录失败:', error);
                this.$message.error('数据加载失败，请稍后重试');
                this.deviceRecordList = [];
                this.totalCount = 0;
            } finally {
                this.loading = false;
            }
        },


        // 显示编辑弹窗
        showEditDialog(row) {
            this.$message.info('编辑功能待实现');
            console.log('待编辑的记录:', row);
        },

        // 表格行点击事件
        handleRowClick(row) {
            this.$refs.tableRef.toggleRowSelection(row);
        }
    }
}
</script>

<style lang="scss" scoped>
.announcement-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    padding: 10px 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 15px;

    .announcement-icon {
        color: #faad14;
        font-size: 20px;
        margin-right: 10px;
    }
}

.device-table-container {
    display: flex;
    flex-direction: column;
    height: calc(100% - 60px);
    overflow: hidden;
}

// --- 自动滚动列表样式 ---
.checkin-overview-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .overview-header {
        display: flex;
        background-color: #f8f9fa;
        font-weight: 600;
        padding: 12px 0;
        border-bottom: 1px solid #e8e8e8;
        z-index: 10;

        .header-item {
            flex: 1;
            text-align: center;
            color: #333;
        }
    }

    .marquee-container {
        flex: 1;
        overflow: hidden;
    }

    .overview-body {
        animation: scroll-up-device-table 60s linear infinite;
        height: 100%;

        &:hover {
            animation-play-state: paused;
        }

        .overview-row {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px dashed #f0f0f0;

            &:hover {
                background-color: #f8f9fa;
            }

            .body-item {
                flex: 1;
                text-align: center;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .empty-tip {
            text-align: center;
            padding: 50px 0;
            color: #999;
        }
    }
}

// 设备列表滚动动画
@keyframes scroll-up-device-table {
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(calc(-100% + 30vh));
    }
}
</style>